<template>
  <ContentSection :spacing="isSidebar ? 'none': 'md'">
    <!-- NEWS TEASER -->
    <!-- TITLE & TEXT -->
    <HeadingAndText :heading="data.heading" :text="data.text" />

    <!-- NEWS ARTICLES -->
    <AnimatedContainer>
      <ul
        class="
          space-y-5
          sm:space-y-7
        "
      >
        <li
          v-for="entry in data.entries"
          :key="entry.id"
          class="slide-left"
        >
          <CardNewsArticle :data="entry" />
        </li>
      </ul>
    </AnimatedContainer>

    <!-- LINK -->
    <AppButton
      v-if="data.link"
      :to="data.link"
      variant="primary"
      class="mt-6"
    >
      {{ $t('more') }}
    </AppButton>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsTeaserNewsFragment } from '#gql'

defineProps<{ data: Enforce<MainComponentsTeaserNewsFragment> }>()

const isSidebar = inject<boolean>('isSidebar', false)
</script>
